import React from 'react'
import { CreateAccountFormRouter } from './CreateBrand'

export const CreateBrandContainer = () => <CreateAccountFormRouter />
